async function getListData(param) {
    const queryParams = new URLSearchParams(param);

    return fetch('/api/users?' + queryParams)
        .then(res => {
            return res;
        })
        .catch(errors => {
            return errors;
        })
}

export { getListData }
